import { Card } from "@/components/ui/card";
import { Clock, MapPin, Laptop } from "lucide-react";
import { useAppSelector } from "@/store/hooks";
import { formatTimestampIST } from "@/utils/sessionHelpers";

export function AppFooter() {
    const { sessions } = useAppSelector((state) => state.auth);
    const lastLogin = sessions?.find((s) => s.is_current);
    const lastLoginTime = lastLogin?.mt ? formatTimestampIST(lastLogin.mt) : "Unknown";

    if (!sessions || sessions.length === 0) return null;

    return (
        <footer className="w-full max-w-[1600px] mx-auto px-4 sm:px-6 lg:px-8 pb-8 pt-4">
            <Card className="glass-card border-border/50">
                <div className="p-6">
                    <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
                        {/* Last Login Info */}
                        <div className="flex items-center gap-6 text-sm">
                            <div className="flex items-center gap-2 text-muted-foreground">
                                <Clock className="w-4 h-4" />
                                <span className="font-medium">Last Login:</span>
                                <span>{lastLoginTime}</span>
                            </div>

                            {lastLogin?.ip && (
                                <div className="flex items-center gap-2 text-muted-foreground">
                                    <MapPin className="w-4 h-4" />
                                    <span>{lastLogin.ip.split(',')[0]?.trim()}</span>
                                </div>
                            )}
                        </div>

                        {/* Session Count */}
                        <div className="flex items-center gap-2">
                            <Laptop className="w-4 h-4 text-muted-foreground" />
                            <span className="text-sm text-muted-foreground">
                                {sessions?.length || 0} active {sessions?.length === 1 ? 'session' : 'sessions'}
                            </span>
                        </div>
                    </div>
                </div>
            </Card>
        </footer>
    );
}
